import css from 'styled-jsx/css';

const styles = css.global`#sec-veja-tambem {
  overflow: hidden;
}

#vejaTambem {
  overflow: visible;
  font-family: 'Open Sans';
}

#vejaTambem h2 {
  margin: 48px 0 42px;
  font-size: 32px;
  color: #222222;
}
.container-veja {
  display: flex;
  margin-bottom: 56px;
  position: relative;
  overflow: visible;
}

.container-veja .slide {
  margin: 0 8px;
  position: relative;
}

.container-veja a.slide{
  flex: 0 0 269px;
}

.container-veja .slide:first-of-type {
  margin-left: 0;
}

.container-veja .slide:last-of-type {
  margin-right: 0;
}

.container-veja h3 {
  color: #fff;
  font-size: 20px;
  position: absolute;
  z-index: 10;
  font-weight: 400;
  padding: 24px;
  max-width: 200px;
  margin: 0;
  line-height: 20px;
  box-sizing: content-box;
}

.container-veja u {
  color: #fff;
  font-size: 16px;
  position: absolute;
  bottom: 34px;
  left: 24px;
  text-decoration: underline;
}

.slider-veja {
  position: relative;
}

@media (min-width: 768px) {
  .container-veja .slide {
    margin: 0 20px;
  }
}

@media (min-width: 992px) {
  #sec-veja-tambem .custom-carousel .fill-height {
    overflow: hidden;
  }
  #sec-veja-tambem .custom-carousel .embla__container {
    overflow: visible;
  }
  #sec-veja-tambem .custom-carousel .embla__prev {
    left: -37px;
    background-size: 2rem;
    background-image: url(static/amp/shared/assets/left-small.png);
  } 
  #sec-veja-tambem .custom-carousel .embla__next {
    right: -37px;
    background-size: 2rem;
    background-image: url(static/amp/shared/assets/right-small.png);
  }
}

@media (min-width: 1400px) {
  #sec-veja-tambem .custom-carousel .embla__prev,
  #sec-veja-tambem .custom-carousel .embla__next {
    display: none;
  }
}`;

export default styles;